import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  gap: 0,
  perView: 1,
  autoplay: 5000,
  bound: true,
};

export default class highlightSlider {
  constructor(el) {
    this.el = el;
    this.initObserver();
  }

  initObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initSlider();
          this.initListener();
          this.initControls();
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(this.el);
  }

  initSlider() {
    this.highlightSlider = new GlideSlider(this.el, glideOptions);
    this.highlightSliderGlideInstance = this.highlightSlider.getGlideSlider();
    this.highlightSliderGlideInstance.mount();

    this.pauseSliderOnMobile();
  }

  initListener() {
    this.highlightSliderGlideInstance.on('run', () => {
      this.el.classList.add('glide--running');
    });

    this.highlightSliderGlideInstance.on('run.after', () => {
      this.el.classList.remove('glide--running');
    });

    window.addEventListener('resize', () => {
      this.pauseSliderOnMobile();
    });
  }

  initControls() {
    const navigationButtons = this.el.querySelectorAll('[data-glide-dir]');

    navigationButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.highlightSliderGlideInstance.pause();
      });
    });
  }

  pauseSliderOnMobile() {
    if (window.innerWidth <= 768) {
      this.highlightSliderGlideInstance.pause();
    }
  }
}
